import { useConfigurationItem } from "features/configuration/GeneralConfiguration/ConfigurationItem/index";
import { useContext } from "react";
import { GeneralConfigurationContext } from "features/configuration/GeneralConfiguration/generalConfigurationContexts";
import { useSharedPriceRangeItem } from "@shared/features/configuration/hooks";
import { ConfigurationItem } from "@shared/types";

const usePriceRangeItem = (item: ConfigurationItem) => {
  const { precisionConfig } = useContext(GeneralConfigurationContext);

  const {
    itemValue,
    itemName,
    itemValueModified,
    handleItemChange,
    originalItemValue,
  } = useConfigurationItem({
    item,
    valueParser: undefined,
  });

  const { validationMessage, error } = useSharedPriceRangeItem(
    itemValue,
    originalItemValue,
    precisionConfig
  );

  return {
    itemName,
    itemValue,
    itemValueModified,
    handleItemChange,
    validationMessage,
    error,
    precisionConfig,
  };
};

export default usePriceRangeItem;
